import * as React from 'react';
import AmlDashMainGrid from '../../components/Dashboard/AmlDashMainGrid';

export default function Dashboard(props) {
  return (
    <AmlDashMainGrid />
  );
}
